import { useMutation, useQuery } from '@tanstack/react-query';

import { DtoV1PropertyTaxSaveTaxSummaryRequestDto } from '~/__generated__/api';
import useUrl from '~/common/hooks/useUrl';
import { typedApiClient } from '~/common/util/api-client';

export const useTaxesSummaryData = () => {
  const { obfuscatedLoanIdentifier } = useUrl();
  const taxesResponse = useQuery({
    queryKey: ['tax-summary'],
    queryFn: async () => {
      const response = await typedApiClient.v1.propertyTaxesTaxSummaryDetail(
        obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
        obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
      );

      return response.data;
    },
  });

  const { mutate: saveTaxSummary } = useMutation({
    mutationKey: ['tax-summary'],
    mutationFn: async (data: DtoV1PropertyTaxSaveTaxSummaryRequestDto) => {
      await typedApiClient.v1.propertyTaxesTaxSummary(
        obfuscatedLoanIdentifier.obfuscatedLenderDatabaseId,
        obfuscatedLoanIdentifier.obfuscatedLoanRecordId,
        data,
      );
    },
  });

  return {
    ...taxesResponse,
    saveTaxSummary,
    obfuscatedLoanIdentifier,
  };
};
